"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FontVariant = void 0;
var FontVariant;
(function (FontVariant) {
    FontVariant["regular"] = "regular";
    FontVariant["bold"] = "bold";
    FontVariant["italic"] = "italic";
    FontVariant["boldItalic"] = "boldItalic";
    FontVariant["weight_100"] = "100";
    FontVariant["weight_200"] = "200";
    FontVariant["weight_300"] = "300";
    FontVariant["weight_500"] = "500";
    FontVariant["weight_600"] = "600";
    FontVariant["weight_700"] = "700";
    FontVariant["weight_800"] = "800";
    FontVariant["weight_900"] = "900";
    FontVariant["italic_100"] = "100italic";
    FontVariant["italic_200"] = "200italic";
    FontVariant["italic_300"] = "300italic";
    FontVariant["italic_500"] = "500italic";
    FontVariant["italic_600"] = "600italic";
    FontVariant["italic_700"] = "700italic";
    FontVariant["italic_800"] = "800italic";
    FontVariant["italic_900"] = "900italic";
})(FontVariant = exports.FontVariant || (exports.FontVariant = {}));
